import { Routes } from "@angular/router";

const loadPublicSignaturePage = () =>
  import("./mobile-public-signature-page/mobile-public-signature-page.component").then(
    (moduleExports) => moduleExports.MobilePublicSignaturePageComponent
  );

export const publicSignatureRoutes: Routes = [
  {
    path: "",
    pathMatch: "full",
    loadComponent: loadPublicSignaturePage,
  },
  {
    path: ":token",
    loadComponent: loadPublicSignaturePage,
  },
];
